import { loadPano } from '../utils/AsyncLoadPano';
import { basepath } from '../utils/config';
// import swf from './tour.swf';
import styles from '../styles/index.less';
// import music from '../components/music';
import { createAvatarHotspot } from '../utils/krpano';
import events from './event';
import defaultPrams from './default';
import $ from 'jquery';
import protos from './protos';
import Jtx from 'yjtec-js-to-xml';

const loadingSvg = '/static/images/new-loading.png';
const loadingVip = '/static/images/new-loading-vip.png';

const { assign } = Object;
const generateId = (() => {
  let i = 0;
  return (prefix = '') => {
    i += 1;
    return `${prefix}${i}`;
  };
})();
let timeout = null;
// const a = swf;
class Pano {
  constructor(props) {
    this.props = props;
    this.uniqueId = generateId('pano-');
    this.panoId = this.uniqueId + '-mainSWFOBJ';
    const { el, ...params } = props;
    this.el = el;
    this.params = assign({}, defaultPrams, params);
    this.krOptions = {};
    Object.keys(protos).forEach(protoName => {
      if (!Pano.prototype[protoName]) { 
        Pano.prototype[protoName] = protos[protoName];
      }
    });
    this.render();
    this.setWxAutoPlayMusic();
  }

  initPano() {
    const params = this.params;
    if (this.params.configOpenCover) {
      this.showOpenCover();
    }
    //添加dom
    const { url, extraPano } = params;
    const krOptions = assign(
      {
        dom: this.uniqueId,
        xml: url,
        js:'https://res.jsvry.cn/krpano/tour.js',
        swf:'https://res.jsvry.cn/krpano/tour.swf'
      },
      this.krOptions,
      extraPano,
    );

    if (!krOptions.xml) return;

    this.krJs = new Jtx(krOptions);
    if (!this.krpano) {
      this.krJs.on('onxmlcomplete',(krpano)=>{
        this.handlePanoReady(krpano);
        if (this.props.onReady && typeof this.props.onReady === 'function') {
          this.props.onReady(krpano);
        }
      })
    }
  }

  handlePanoReady = krpano => {
    this.krpano = krpano;
    events(krpano, this);

    //初始渲染完成调用
    if (!this.loaded) {
      this.onLoadcomplete();
      this.hideLoading();
      this.setSceneList(this.params.configScenes);
      this.loaded = true;
    }
  };

  hideLoading() {
    this.$loading.fadeOut('normal', () => {
      this.$loading.remove();
    });
    clearTimeout(timeout);
  }

  onLoadcomplete() {
    //首个场景xml渲染完成时执行
    const { configOpenTip } = this.params;
    if (configOpenTip) {
      this.showOpenTip();
    }
    if (this.props.onLoaded && typeof this.props.onLoaded === 'function') {
      this.props.onLoaded(krpano);
    }

    this.showProjectInfo();
  }
  renderPano() {
    let params = this.params;
    if (params.showPanoLoading) {
      this.$container.append(this.$loading);
      const isVip = this.params.auther.is_vip || this.params.configPanoInfo.project_vip;
      if (isVip && (!this.params.loading.url || JSON.stringify(this.params.loading.url) == '[]')) {
        this.loadingAnimation();
      }
    }
    this.initPano();
  }

  loadingAnimation(index = 1){
    let $loadingDom = document.getElementById('loading');
    let i = index;
    let _this = this;
    timeout = setTimeout(function(){
        $loadingDom.style.backgroundPosition = '0 -'+ i*200 +'px';
        if (i == 35) {
            i = 0
        }
        _this.loadingAnimation(i+1); 
    },60);
  }
  render() {
    let params = this.params;
    if (this.$el || !this.el) return;
    const isVip = this.params.auther.is_vip || this.params.configPanoInfo.project_vip;
    this.$el = $(this.el);
    this.$pano = $(`<div class="${styles['pano-wrapper']}" id="${this.uniqueId}"></div>`);
    //加载图片
    if (this.params.loading.url && JSON.stringify(this.params.loading.url) != '[]') {
      this.$loading = $(`
        <div class="${styles['loading-modal']} ${styles['full-modal']}">
          <img src="${this.params.loading.url}" width="100"/>
        </div>
      `);
    }else{
      // this.$loading = $(`
      //   <div class="${styles['loading-modal']} ${styles['full-modal']}">
      //     <img src="${isVip ? loadingVip : loadingSvg}" class="${styles['loading-loop']}" width="100"/>
      //   </div>
      // `); 
      this.$loading = $(`
        <div class="${styles['loading-modal']}">
          <div style="width: 100px;height: 100px;background-image: url('${isVip ? loadingVip : loadingSvg}');background-size: 100px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);" id="loading">
          </div>
        </div>
      `);
    }
    this.$container = $(`<div class="${styles['container']}"></div>`);
    this.$container.append(this.$pano);
    this.$el.append(this.$container);
    if (params.needAuth) {
      this.showAuth();
    } else {
      this.renderPano();
    }
  }
}

export default Pano;
 